import { createReducer, on } from '@ngrx/store';
import {
  loadIndustriesOrSectorsFailure,
  loadIndustriesOrSectorsSuccess,
  toggleIndustriesOrSectorsLoading,
} from './industries-or-sectors.actions';
import { initialUIState } from './industries-or-sectors.state';

export const industriesOrSectorsReducer = createReducer(
  initialUIState,
  on(toggleIndustriesOrSectorsLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadIndustriesOrSectorsSuccess, (state, { industriesOrSectors }) => ({
    ...state,
    list: industriesOrSectors,
    isLoading: false,
  })),
  on(loadIndustriesOrSectorsFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);